import React from 'react';
import { Alert, Button } from 'antd';

const RETRY_LABEL = 'Retry';

// The shared restApi already retries GETs 3× on 5xx, so by the time this shows
// the request has failed four times — hence the explicit next step rather than
// "try again later".
const DESCRIPTION = "We couldn't fetch the data. Check your connection and try again.";

export type SearchPerformanceRequestErrorProps = {
  /**
   * Scoped to the widget that failed, not the page — one widget's failure says
   * nothing about the others once the charts and tables land.
   */
  message: string;
  onRetry: () => void;
};

function SearchPerformanceRequestError({ message, onRetry }: SearchPerformanceRequestErrorProps) {
  return (
    <Alert
      type="error"
      showIcon
      message={message}
      description={DESCRIPTION}
      action={
        <Button size="small" onClick={onRetry}>
          {RETRY_LABEL}
        </Button>
      }
    />
  );
}

export default SearchPerformanceRequestError;
